import { Button } from '@chakra-ui/react';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProgramDeletionDialog from './ProgramDeletionDialog';
import { Trash } from 'iconoir-react';

interface DeleteProgramButtonProps {
  programId: string;
  programName: string;
  disabled?: boolean;
}

const DeleteProgramButton: React.FC<DeleteProgramButtonProps> = ({
  programId,
  programName,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <Button colorPalette="red" variant="solid" onClick={handleOpenDialog} disabled={disabled}>
        <Trash width={16} height={16} />
        {t('programs.deletion.button')}
      </Button>

      <ProgramDeletionDialog
        isOpen={isDialogOpen}
        programId={programId}
        programName={programName}
        onClose={handleCloseDialog}
      />
    </>
  );
};

export default DeleteProgramButton;
